import React, { useState, useEffect } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { logOut } from "../../utils/login";
import { useDispatch } from "react-redux";
import { alphaList } from "../../utils/functions";
import "../../style/Liste.css";

import { useToasts } from "react-toast-notifications";
import { MDBBtn } from "mdbreact";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function Marques() {
  const [marques, setMarques] = useState([]);
  const [marquesMagasin, setMarquesMagasin] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const getMarques = axios.get(`${API_URL}/api/marques`);
  const getMarquesMagasin = axios.get(
    `${API_URL}/api/marques/marques-travaillees`,
    { headers: { authorization: `Bearer ${token}` } }
  );

  useEffect(() => {
    function getMarquesAndSelected() {
      axios
        .all([getMarques, getMarquesMagasin])
        .then((res) => {
          const marquesMagasinIdArray = res[1].data.map((a) => a.id);
          setMarques(alphaList(res[0].data));
          setMarquesMagasin(marquesMagasinIdArray);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            addToast("Votre session est expirée. Merci de vous reconnecter.", {
              appearance: "warning",
              autoDismiss: true,
            });
            logOut();
            dispatch({ type: "LOGOUT" });
            history.push("/login");
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }

    getMarquesAndSelected();
  }, []);

  const handleCheck = (e) => {
    const checked = e.target.checked;
    const marqueSelect = e.target.id;
    if (checked) {
      setMarquesMagasin([...marquesMagasin, Number(marqueSelect)]);
    } else {
      setMarquesMagasin(() =>
        marquesMagasin.filter((marque) => marque !== Number(marqueSelect))
      );
    }
  };

  function submitMarques(selection) {
    axios
      .put(`${API_URL}/api/marques/marquesselect`, selection, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        addToast("Marques enregistrées !", {
          appearance: "success",
          autoDismiss: true,
        });
        setRedirect(true);
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Toutes les marques</title>
      </Helmet>
      {redirect && <Redirect to="/magasin/marques" />}
      <h1>Sélectionner mes marques</h1>
      <ul className="listContainer">
        {marques ? (
          Object.keys(marques).map((key) => (
            <div className="oneLetterContainer">
              <h2>{key}</h2>
              {marques[key].map((marque) => (
                <li key={marque.id}>
                  <input
                    type="checkbox"
                    id={marque.id}
                    name={marque.nom}
                    checked={marquesMagasin.includes(marque.id)}
                    onChange={handleCheck}
                  />{" "}
                  <label htmlFor={marque.id}> {marque.nom}</label>
                </li>
              ))}
            </div>
          ))
        ) : (
          <li>Loading</li>
        )}
      </ul>
      <div className="marqueButtonContainer">
        <MDBBtn
          type="button"
          outline
          color="primary"
          onClick={() => setRedirect(true)}
        >
          Annuler
        </MDBBtn>
        <MDBBtn
          type="button"
          color="primary"
          disabled={marquesMagasin.length === 0 ? true : false}
          onClick={() => submitMarques(marquesMagasin)}
        >
          Enregistrer
        </MDBBtn>
      </div>
    </div>
  );
}

export default Marques;
